var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';
import DistriDialog from '../../businessgoodsprice/components/ApplyClientsDialog';
var GoodsList = (function (_super) {
    __extends(GoodsList, _super);
    function GoodsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.frontData = [];
        return _this;
    }
    GoodsList.prototype.chooseBusiness = function () {
        var _this = this;
        var business_ids = (this.businessInfo && this.businessInfo.business_ids) || [];
        var group_ids = (this.businessInfo && this.businessInfo.group_ids) || [];
        var dialog = this['$dialog'](DistriDialog, {
            data: {
                business_ids: business_ids,
                group_ids: group_ids,
                descHtml: "\u6309\u7EC4\u751F\u6548\uFF1A\u9664\u5F53\u524D\u8BE5\u5BA2\u6237\u5206\u7EC4\u4E0B\u6240\u6709\u5BA2\u6237\u5E94\u7528\u6B64\u6D3B\u52A8\uFF0C\u540E\u7EED\u6DFB\u52A0\u5230\u8BE5\u7EC4\u4E0B\u7684\u5BA2\u6237\u4E5F\u9ED8\u8BA4\u5E94\u7528\u8BE5\u6D3B\u52A8<br/>\n                        \u4E34\u65F6\u5BA2\u6237\u5206\u7EC4\uFF1A\u6240\u6709\u65B0\u6CE8\u518C\u7684\u7528\u6237\u4F1A\u81EA\u52A8\u8FDB\u5165\u4E34\u65F6\u5BA2\u6237\u5206\u7EC4\uFF0C\u5982\u9700\u5355\u72EC\u7BA1\u7406\u5BA2\u6237\u8BF7\u5728\u5BA2\u6237\u5206\u7EC4\u4E2D\u8C03\u6574",
                requiredChooseNum: false,
            },
        }, {
            title: '选择客户',
            width: 640,
            height: 530,
        });
        dialog.instance.$on("submit", function (res) {
            _this.$emit('changeBusinessSelect', res);
            _this.createPager();
        });
    };
    GoodsList.prototype.pageChange = function (pager) {
        this.createPager(pager);
    };
    GoodsList.prototype.createPager = function (pager) {
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var frontData = [];
        var startIndex = pager.start;
        var endIndex = pager.start + pager.limit - 1;
        for (var i = startIndex; i <= endIndex; i++) {
            if (!this.listData[i]) {
                break;
            }
            frontData.push(this.listData[i]);
        }
        this.frontData = frontData;
    };
    __decorate([
        Prop({
            required: true,
        })
    ], GoodsList.prototype, "mode", void 0);
    __decorate([
        Prop()
    ], GoodsList.prototype, "listData", void 0);
    __decorate([
        Prop()
    ], GoodsList.prototype, "businessInfo", void 0);
    GoodsList = __decorate([
        Component({
            watch: {
                listData: {
                    immediate: true,
                    handler: function (newValue, oldVal) {
                        this.createPager();
                    }
                }
            },
        })
    ], GoodsList);
    return GoodsList;
}(Vue));
export default GoodsList;
